const gudaiyanqing = {
  category: '古代言情',
  categoryId: '17',
  coverList: [
    {
      coverId: 17001,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #D54326 0%, #4E0B0B 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '47',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#A3311B',
      },
      padding: 48,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/1-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17002,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#000',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #FBF7A7 100%)',
        color_mask: '#FBF7A7',
        font: '潮字社曾玉波手书简',
        fontSize: '68',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/2-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 17003,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #858BBB 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#A3311B',
      },
      padding: 7,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/3-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17004,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #858BBB 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#A3311B',
      },
      padding: 7,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/4-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17005,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #858BBB 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '47',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#A3311B',
      },
      padding: 30,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/5-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17006,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #858BBB 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '47',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#A3311B',
      },
      padding: 48,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/6-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17007,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#374DAA',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFF4D7 0%, #9B471D 100%)',
        color_mask: '#10162A',
        font: '潮字社曾玉波手书简',
        fontSize: '47',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#233067',
      },
      padding: 48,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/7-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17008,
      template: 'vertical_1',
      title: {
        titleText: '',
        color: '#374DAA',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #374DAA 0%, #10162A 100%)',
        color_mask: '#10162A',
        font: '潮字社曾玉波手书简',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#233067',
      },
      padding: 7,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/8-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #333046)"
      },
    },
    {
      coverId: 17009,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#5E41AD',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(180deg, #5E41AD 0%, #06030A 100%)',
        color_mask: '#06030A',
        font: '潮字社曾玉波手书简',
        fontSize: '68',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#100A1D',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/9-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #fff)"
      },
    },
    {
      coverId: 17010,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#D54326',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(180deg, #D54326 0%, #4E0B0B 100%)',
        color_mask: '#4E0B0B',
        font: '潮字社曾玉波手书简',
        fontSize: '68',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#5A110E',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/gudaiyanqing/10-cover.png',
        // textBackground: "linear-gradient(to bottom, transparent 50%, #fff)"
      },
    },
  ],
};

export default gudaiyanqing;
